import { Colors } from '@kvika/audur-theme'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts'

type INewCalculatorLineChartProps = {
	title: string
	data?: {
		year: number
		value: number
	}[]
	color?: string
}

const NewCalculatorLineChart = (props: INewCalculatorLineChartProps) => {
	const { data, title, color = Colors.LightOrange } = props

	return (
		<>
			<div>{title}</div>
			<ResponsiveContainer width='100%' height={250}>
				<LineChart data={data} margin={{ top: 20, right: 0, left: 20, bottom: 10 }}>
					<CartesianGrid strokeDasharray='2' vertical={false} stroke={Colors.LightGray} />
					<XAxis
						dataKey='year'
						axisLine={{ strokeDasharray: '2', stroke: '#BEB8C4' }}
						tickLine={false}
						tick={{ fontSize: 12, color: '#DBDBDB', fill: '#DBDBDB', fontWeight: 400, opacity: 0.8, dy: 13 }}
					/>
					<YAxis
						axisLine={false}
						tickLine={false}
						tick={{
							fontSize: 12,
							color: '#DBDBDB',
							fill: '#DBDBDB',
							opacity: 0.8,
							fontWeight: 400,
							dx: -70,
							dy: -3,
							width: 100,
							textAnchor: 'start',
						}}
						tickFormatter={(value) => {
							if (value > 1_000_000) {
								const millions = (value / 1_000_000).toFixed(0)
								return `${millions} m.kr.`
							}
							if (value > 1_000) {
								const thousands = (value / 1_000).toFixed(0)
								return `${thousands} þ.kr.`
							}
							return `${value} kr.`
						}}
						tickCount={3}
					/>
					<Line dataKey='value' name={title} fill={color} dot={false} stroke={color} strokeWidth={5} />
				</LineChart>
			</ResponsiveContainer>
		</>
	)
}

export default NewCalculatorLineChart
